export const checkIsStringedDatesListValid = (
  stringedDates: string[],
): boolean => {
  if (stringedDates.length === 0) {
    return false;
  }

  const dateRegExp =
    /^((0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])(\s(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2]))*)?$/;

  return stringedDates.every((stringedDate) => dateRegExp.test(stringedDate));
};
